<!--
<footer>
    <p>
        © 2020 Al-Arbuli S.C.A. |
        <a >Aviso Legal</a> | 
        <a >Política de cookies</a> |
        <a >Política de privacidad</a>
    </p>
</footer>
-->
<footer>
    <div class="container-fluid">
        <div class="row justify-content-center align-items-center">
            <div class="col d-flex justify-content-center">
                <span>© 2020 Al-Arbuli S.C.A.</span>
            </div>
        </div>
    </div>
</footer>